import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import FormHero from '../components/FormHero'
import Form from '../components/Form'

const Contact = () => {
  return (
    <div>
        <Navbar />
        <FormHero />
        <Form />
        <Footer />
    </div>
  )
}

export default Contact